import { DecimalPipe } from '@angular/common';
import { Component, EventEmitter, input, Output, signal, WritableSignal, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { NotificationVisualType } from './notification.service';

/**
 * Do not manually create instances of this. Use the NotificationService and the Notify() method
 * to generate notifications. Also, verify you have placed a single instance of the notifications-container
 * component into the app.component.html before using notifications. Otherwise, nothing will show up
 * when you call Notify()
 */
@Component({
  selector: 'app-notification',
  imports: [DecimalPipe],
  templateUrl: './notification.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './notification.component.scss'
})
export class NotificationComponent implements OnInit, OnDestroy {
  public Message = input<string>("");
  /**
   * The time this notification will stay on screen in milliseconds. Use 0 for infinite time.
   */
  public DisplayTime = input<number>(0);
  public VisualType = input.required<NotificationVisualType>();
  /**
   * The time left, in seconds, before this notification will fire
   * OnDisplayTimeFinished.
   */
  public TimeLeft: WritableSignal<number> = signal(0);
  @Output()
  public OnDisplayTimeFinished = new EventEmitter<void>();
  @Output()
  public OnClosingAnimationFinished = new EventEmitter<void>();
  public DisplayTimeEnded: WritableSignal<boolean> = signal(false);

  private IntervalId: ReturnType<typeof setInterval> | undefined = undefined;

  public ngOnInit(): void{
    if (this.DisplayTime() > 0){
      this.TimeLeft.set(this.DisplayTime() / 1000);
      this.IntervalId = setInterval(() => {
        this.TimeLeft.update((current) => {
          if (current - 1/1000 * 10 < 0){
            return 0;
          }else{
            return current - 1/1000 * 10;
          }
        });
        if (this.TimeLeft() <= 0){
          this.OnFinishedDisplaying();
        }
      }, 10);
    }
  }

  /**
   * When the slide-out CSS animation ends
   */
  public OnAnimationEnd(): void{
    this.OnDisplayStateClosedAnimationFinished();
  }

  /**
   * Called in the ngOnInit() interval when the display time
   * is finished, or when the close button is clicked.
   */
  private OnFinishedDisplaying(): void{
    clearInterval(this.IntervalId);
    this.IntervalId = undefined;
    this.OnDisplayTimeFinished.emit();
    this.DisplayTimeEnded.set(true);
  }

  /**
   * Called when the animation for closing (sliding off screen) finishes.
   */
  public OnDisplayStateClosedAnimationFinished(): void{
    this.OnClosingAnimationFinished.emit();
  }

  public OnCloseButtonClicked(): void{
    this.OnFinishedDisplaying();
  }

  public ngOnDestroy(): void{
    if (this.IntervalId !== undefined){
      clearInterval(this.IntervalId);
    }
  }
}